const data = (state, stateFilter) => {
  if (state.coaches == null) {
    return null;
  }

  return state.coaches.filter((item) => {
    let available = true;

    let filter_keys = Object.keys(stateFilter.selected);

    if (stateFilter.showSelectedOnly) {
      available = state.coachSelected.includes(item.id);
    }

    if (available) {
      if (
        !item.attributes.full_name
          .toLowerCase()
          .includes(stateFilter.coachName.toLowerCase())
      )
        available = false;
    }

    filter_keys.forEach((key) => {
      if (available) {
        const values = stateFilter.selected[key];
        if (values.length > 0) {
          if (key.includes("_ids")) {
            available = values.some(
              (r) => item.attributes[key].indexOf(r) >= 0
            );
          } else {
            available = values.includes(item.attributes[key]);
          }
        }
      }
    });

    return available;
  });
};

export default data;
